/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProductListAssignmentOperation = {
    Assign: 'assign',
    Unassign: 'unassign'
} as const;
export type ProductListAssignmentOperation = typeof ProductListAssignmentOperation[keyof typeof ProductListAssignmentOperation];


// @ts-ignore
export function ProductListAssignmentOperationFromJSON(json: any): ProductListAssignmentOperation {
    return ProductListAssignmentOperationFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductListAssignmentOperationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListAssignmentOperation {
    return json as ProductListAssignmentOperation;
}

// @ts-ignore
export function ProductListAssignmentOperationToJSON(value?: ProductListAssignmentOperation | null): any {
    return value as any;
}

